module.exports = __webpack_public_path__ + "static/media/iconfinder_Cancel_1493282.d21ac26b.png";